<template>
  <div class="d-flex flex-wrap">
    <h2 class="col-3 mb-4">{{ $t('autocaller_v2.monitoring.rooms.topic') }}</h2>
    <filter-rooms @filter="filter" />
    <div class="col-12">
      <filtered-rooms :rooms="rooms" />
    </div>
  </div>
</template>

<script>
  import FilterRooms from './monitoring-filter-rooms'
  import FilteredRooms from './monitoring-filtered-rooms'
  export default {
    components: {
      FilteredRooms,
      FilterRooms
    },
    props: {
      tasks: {
        type: [Object, Array],
        default: () => {}
      }
    },
    data() {
      return {
        state: []
      }
    },
    computed: {
      nul() {
        if(Object.keys(this.tasks).length != 0) {
          return '1';
        }
        return null
      },
      rooms() {
        if(this.nul) {
          let rooms = this.tasks.operators.filter( item => item.room != null);
          let tasks = this.tasks.tasks;
          rooms.filter(room => tasks.some(function(task) { if(room.room.task_id === task.id) {room.number = task.number} } ));
          if(rooms.length == 0) {
            return null
          }
          if(this.state.length) {
            return rooms.filter(item => this.state.some(s => item.room.state == s ) )
          }
          return rooms;
        }
        return null
      }
    },
    methods: {
      filter(state) {
        this.state = state;
      }
    }
  }
</script>
